import React from 'react';
import PropTypes from 'prop-types';
import { PasswordResetFormView } from '../../../components';
import { modalViewGA } from '../../../utils/googleAnalytics';

const contextTypes = {
  router: PropTypes.object
};

class ResetPasswordComponent extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    modalViewGA('reset-password');
  }

  closeModal(e) {
    this.props.removeModal();
    this.context.router.push('/livecams');
    e.preventDefault();
  }

  render(){
    return (
    <div>
      <div className="modals-popup reset-password-modal">
        <div className="modal-header d-flex align-items-center">
          <div className="col">Password Reset</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>

        <div className="info">
          <div className="p-20">
            <PasswordResetFormView closeModal={this.closeModal} />
          </div>
        </div>
      </div>
    </div>
    );
  }
}

ResetPasswordComponent.contextTypes = contextTypes;

export default ResetPasswordComponent;
